import fp from 'lodash/fp';
import {
  branchFuncs
} from '.';

export const pluralise = (text, count) => `${text}${count !== 1 ? 's' : ''}`;

export const stringConcat = fp.rearg([1, 0], (x, y) => `${x}${y}`);

export const possessiveCase = branchFuncs(
  fp.overSome([fp.endsWith('\'s'), fp.endsWith('s\'')]),
  fp.identity,
  branchFuncs(
    fp.endsWith('s'),
    stringConcat('\''),
    stringConcat('\'s')
  )
);



// WEBPACK FOOTER //
// ./src/utils/string.js